import { AuthService } from '@/shared/api';
import { useFetchComposable } from '@/shared/lib';

const useUserGetMe = () => {
  const { send: userGetMe } = useFetchComposable(AuthService.getMe);

  return { userGetMe };
};

export { useUserGetMe };
